import { isAxiosError, type AxiosError } from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { getAxiosErrorData } from "@utils/common";

export const useBudgetFunctionalityDisabledError = () => {
  const { t } = useTranslation();

  const handleBudgetError =
    (fallBackHandler: (err: AxiosError<unknown, unknown>) => void) =>
    (err: AxiosError) => {
      if (isAxiosError(err)) {
        const axiosError = getAxiosErrorData(err);
        if (
          axiosError.errorCode === "PermissionError" &&
          axiosError.messageCode === "BudgetFunctionalityDisabled"
        ) {
          toast.error(t("validationErrors.BudgetFunctionalityDisabled"));
        } else {
          fallBackHandler(err);
        }
      }
    };

  return { handleBudgetError };
};
